module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0108.jpg?v=31ba12c8";